import request from '@/utils/request_common';

export interface PopupNoticeQuestionOption {
  id: number;
  optionLabel: string;
  optionValue?: string;
}

export interface PopupNoticeQuestion {
  id: number;
  questionTitle: string;
  questionType: 'SINGLE_CHOICE' | 'TEXT';
  isRequired?: number;
  optionList?: PopupNoticeQuestionOption[];
}

export interface PopupNoticeItem {
  id: number;
  popupTitle: string;
  popupContent: string;
  popupLink?: string;
  noticeType?: string;
  priorityLevel?: number;
  remainingDays?: number;
  isForceShow?: number;
  isAllowClose?: number;
  isAllowDelay?: number;
  isAllowFeedback?: number;
  isNeedAck?: number;
  processStatus?: string;
  delayStatus?: string;
  questionList?: PopupNoticeQuestion[];
}

export const popupNoticeCurrentApi = (data: any) =>
  request({
    url: '/appInstitution/popupNotice/current',
    method: 'post',
    data
  });

export const popupNoticeDetailApi = (taskId: number) =>
  request({
    url: `/appInstitution/popupNotice/detail/${taskId}`,
    method: 'get'
  });

export const popupNoticeAckApi = (taskId: number) =>
  request({
    url: `/appInstitution/popupNotice/ack/${taskId}`,
    method: 'post'
  });

export const popupNoticeCloseApi = (taskId: number) =>
  request({
    url: `/appInstitution/popupNotice/close/${taskId}`,
    method: 'post'
  });

export const popupNoticeSubmitFeedbackApi = (data: any) =>
  request({
    url: '/appInstitution/popupNotice/submitFeedback',
    method: 'post',
    data
  });
